import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import version from '../version';

let ddLogsInitialized = false;
let ddRumInitialized = false;

export const setUpDDLogging = (env) => {
  if (ddLogsInitialized) {
    return;
  }
  datadogLogs.init({
    clientToken: 'pub2016e63939694771be3727e4c6a1211e',
    env,
    forwardErrorsToLogs: false,
    service: 'taxi-client',
    sessionSampleRate: 100,
    site: 'datadoghq.com',
  });
  ddLogsInitialized = true;
};

export const setUpDDRUM = (env) => {
  if (ddRumInitialized) {
    return;
  }
  datadogRum.init({
    applicationId: '9248d363-a782-4799-a091-bd945a5a4a6e',
    clientToken: 'pub13ecd54359493aa5966cd790a071f623',
    site: 'datadoghq.com',
    service: 'taxi-client',
    env,
    version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'allow',
  });
  ddRumInitialized = true;
};
